"use client";

import { useCart } from "~/lib/hooks/useCart";
import CloseSvg from "~/public/icons/32px/Close.svg";
import styles from "./Cart.module.css";

export const CartHeader = () => {
	const { modal } = useCart();

	return (
		<div className={styles["cart-header"]}>
			<p>Din handlekurv</p>

			<button className={styles["close-button"]} onClick={modal.closeModal}>
				<CloseSvg />
			</button>
		</div>
	);
};
